import React, { useCallback, useState } from 'react';
import { ContentManagementSection } from './ContentManagementNav';
import { ErrorBoundary } from './shared/ErrorBoundary';
import { ArticleGeneration } from './sections/ArticleGeneration/ArticleGeneration';
import { PromptManagement } from './sections/PromptManagement/PromptManagement';
import { SupportingDataManagement } from './sections/SupportingData/SupportingDataManagement';
import { ContentInventorySection } from './sections/ContentInventory/ContentInventorySection';
import { PerformanceDashboard } from './sections/Performance/PerformanceDashboard';
import { HealthChecksSection } from './sections/HealthChecks/HealthChecksSection';
import { EditorialMemorySection } from './sections/EditorialMemory/EditorialMemorySection';

const ContentManagementProject: React.FC<{
  activeSection?: ContentManagementSection;
  onSectionChange?: (section: ContentManagementSection) => void;
}> = ({ activeSection = 'articles', onSectionChange }) => {
  const [pendingArticleId, setPendingArticleId] = useState<string | null>(null);

  const navigateToArticle = useCallback((candidateId: string) => {
    setPendingArticleId(candidateId);
    onSectionChange?.('articles');
  }, [onSectionChange]);

  let content: React.ReactNode;
  let label: string;

  switch (activeSection) {
    case 'prompts':
      content = <PromptManagement />;
      label = 'Prompts';
      break;
    case 'supporting-data':
      content = <SupportingDataManagement />;
      label = 'Supporting Data';
      break;
    case 'inventory':
      content = <ContentInventorySection />;
      label = 'Content Inventory';
      break;
    case 'performance':
      content = <PerformanceDashboard />;
      label = 'Performance';
      break;
    case 'health':
      content = <HealthChecksSection onNavigateToArticle={navigateToArticle} />;
      label = 'Health Checks';
      break;
    case 'editorial-memory':
      content = <EditorialMemorySection />;
      label = 'Editorial Memory';
      break;
    case 'articles':
    default:
      content = <ArticleGeneration initialArticleId={pendingArticleId} onArticleSelected={() => setPendingArticleId(null)} />;
      label = 'Article Generation';
      break;
  }

  return <ErrorBoundary key={activeSection} label={label}>{content}</ErrorBoundary>;
};

export default ContentManagementProject;
